import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-4xl font-bold text-lime-600 my-5'>About Us</h1>
            <p className='text-xl bg-lime-100 p-5'>We have kept this page to keep details of our company, business and to introduce ourselves to our respected viewers. We r still working on this .</p>
        </div>
    );
};

export default About;